export default __webpack_public_path__ + "static/AeonikPro-Bold-a1a506d56375b642c494f168e47a5b0d.woff";